/* ── DATA & STATE ── */
// PRODUCTS populated by Liquid
let activeCat = 'all';
let activeSub = '';
let activeFilters = { stone:[], gold:[], price:50000, personalized: false, engraved: false };

/* ── Mappings for pluralization fix ── */
const CAT_MAP = {
  'earrings': 'earring',
  'rings': 'ring',
  'necklaces': 'necklace',
  'bracelets': 'bracelet',
  'pendants': 'pendant',
  'charms': 'charm',
  'piercings': 'piercing'
};

/* ── Categories that span multiple product types ── */
const CAT_MULTI = {
  'pendants': ['pendant', 'pendants', 'charm', 'charms'],
  'piercings': ['piercing', 'piercings', 'cartilage']
};

/* ── Currency formatter — consistent ₹ symbol ── */
function fmt(n){ return '₹' + Math.round(n).toLocaleString('en-IN'); }

function renderActiveFilters() {
  const bar = document.getElementById('activeFiltersBar');
  if(!bar) return;
  
  let tags = [];
  activeFilters.stone.forEach(s => tags.push({ label: s.replace(/-/g, ' '), type: 'stone', val: s }));
  activeFilters.gold.forEach(g => tags.push({ label: g + ' Gold', type: 'gold', val: g }));
  const maxPrice = parseInt(document.getElementById('priceSlider')?.max || 50000);
  if(activeFilters.price < maxPrice) tags.push({ label: 'Up to ' + fmt(activeFilters.price), type: 'price' });
  if(activeFilters.personalized) tags.push({ label: 'Personalised', type: 'personalized' });
  if(activeFilters.engraved) tags.push({ label: 'Engraved', type: 'engraved' });

  if(tags.length === 0) {
    bar.innerHTML = '';
    return;
  }

  bar.innerHTML = tags.map(t => `
    <div class="filter-tag">
      ${t.label}
      <button class="filter-tag-remove" data-type="${t.type}" data-val="${t.val || ''}">×</button>
    </div>
  `).join('');

  bar.querySelectorAll('.filter-tag-remove').forEach(btn => {
    btn.addEventListener('click', () => {
      const { type, val } = btn.dataset;
      if(type === 'stone') activeFilters.stone = activeFilters.stone.filter(x => x !== val);
      if(type === 'gold') activeFilters.gold = activeFilters.gold.filter(x => x !== val);
      if(type === 'price') {
        const slider = document.getElementById('priceSlider');
        const maxVal = parseInt(slider?.max || 50000);
        activeFilters.price = maxVal;
        if(slider) slider.value = maxVal;
        const valDisp = document.getElementById('priceVal');
        if(valDisp) valDisp.textContent = fmt(maxVal);
      }
      if(type === 'personalized') {
        activeFilters.personalized = false;
        const cb = document.getElementById('filterPersonalized');
        if(cb) cb.checked = false;
      }
      if(type === 'engraved') {
        activeFilters.engraved = false;
        const cb = document.getElementById('filterEngraved');
        if(cb) cb.checked = false;
      }

      // Update checkboxes
      if(val && type !== 'personalized') {
        const cb = document.querySelector(`input[data-filter="${type}"][value="${val}"]`);
        if(cb) cb.checked = false;
      }
      
      renderGrid();
    });
  });
}

function renderGrid(){
  const grid = document.getElementById('productGrid');
  const empty = document.getElementById('emptyState');
  if(!grid) return;

  let filtered = PRODUCTS.filter(p => {
    // Category filter — supports multi-type categories (pendants+charms, piercings+cartilage)
    if(activeCat !== 'all') {
      if(activeCat === 'new-in') {
        if(p.badge !== 'new') return false;
      } else if(CAT_MULTI[activeCat]) {
        if(!CAT_MULTI[activeCat].includes(p.cat)) return false;
      } else {
        const matchCat = CAT_MAP[activeCat] || activeCat;
        if(p.cat !== matchCat && p.cat !== activeCat) return false;
      }
    }

    if(activeSub && p.sub !== activeSub) return false;
    if(activeFilters.stone.length && !activeFilters.stone.includes(p.stone)) return false;
    // Metal filter: 'both' means the product offers yellow AND white gold — matches either filter
    if(activeFilters.gold.length && p.gold !== 'both' && !activeFilters.gold.includes(p.gold)) return false;
    if(p.price > activeFilters.price) return false;
    if(activeFilters.personalized && !p.personalized) return false;
    if(activeFilters.engraved && !p.engraved) return false;
    return true;
  });

  const sort = document.getElementById('sortSelect')?.value || 'default';
  if(sort === 'price-asc')    filtered.sort((a,b) => a.price - b.price);
  if(sort === 'price-desc')   filtered.sort((a,b) => b.price - a.price);
  if(sort === 'new')          filtered.sort((a,b) => (b.badge==='new'?1:0)-(a.badge==='new'?1:0));
  if(sort === 'bestseller')   filtered.sort((a,b) => (b.badge==='bestseller'?1:0)-(a.badge==='bestseller'?1:0));

  document.getElementById('gridCount').textContent = `${filtered.length} piece${filtered.length!==1?'s':''}`;
  
  if(filtered.length === 0){
    grid.innerHTML = '';
    empty.classList.add('visible');
  } else {
    empty.classList.remove('visible');
    grid.innerHTML = filtered.map(p => {
      const soon = p.price === 0;
      let badge = '';
      if (soon)                      badge = `<span class="p-badge-v2 badge-soon-v2">coming soon</span>`;
      else if (p.badge==='new')      badge = `<span class="p-badge-v2 badge-new-v2">new in</span>`;
      else if (p.badge==='bestseller') badge = `<span class="p-badge-v2 badge-bs-v2">bestseller</span>`;
      const personBadge = p.personalized ? `<span class="p-badge-v2 badge-personalised-v2">personalised</span>` : '';
      const engraveBadge = p.engraved ? `<span class="p-badge-v2 badge-engraved-v2">engraved</span>` : '';

      const img = p.img
        ? `<img src="${p.img}" alt="${p.name}" class="p-img" loading="lazy">`
        : `<div class="p-placeholder-kitchen"><svg viewBox="0 0 72 72" width="40" height="40" opacity="0.2"><rect x="20" y="20" width="32" height="32" rx="4" transform="rotate(45 36 36)" fill="currentColor"/></svg></div>`;

      const quickAdd = soon ? '' : `
        <button class="p-add-v2" data-quick-add="${p.id}" data-handle="${p.handle}" aria-label="Quick Add" onclick="event.preventDefault();">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" width="18" height="18">
            <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
          </svg>
        </button>`;

      const price = soon
        ? `<div class="p-price-v2 p-price--soon">Coming Soon</div>`
        : `<div class="p-price-v2">${fmt(p.price)}</div>`;

      return `
        <div class="p-card${soon ? ' p-card--coming-soon' : ''}">
          <a href="${p.url}" class="p-card-inner">
            <div class="p-img-wrap">
              ${badge}${personBadge}${engraveBadge}${img}${quickAdd}
            </div>
            <div class="p-info-v2">
              <h3 class="p-name-v2">${p.name}</h3>
              <p class="p-meta-v2">${p.material || 'Solid 9K Gold'}</p>
              ${price}
            </div>
          </a>
        </div>`;
    }).join('');
  }
  
  renderActiveFilters();
}

/* ── Category nav ── */
function setCategory(cat){
  activeCat = cat;
  activeSub = '';
  document.querySelectorAll('.cat-btn').forEach(b => b.classList.toggle('active', b.dataset.cat === cat));
  
  const subRow = document.getElementById('subRow');
  const productsInCat = cat === 'all' ? PRODUCTS : PRODUCTS.filter(p => {
    const matchCat = CAT_MAP[cat] || cat;
    return p.cat === matchCat || p.cat === cat || (cat === 'new-in' && p.badge === 'new');
  });
  
  const subs = [...new Set(productsInCat.map(p => p.sub).filter(s => s !== ''))];

  if(subs.length){
    subRow.classList.remove('hidden');
    subRow.innerHTML = subs.map(s => {
      const label = s.replace(/-/g, ' ');
      let displayLabel = label;
      if (s === '1mm') displayLabel = '1mm band';
      if (s === 'personalised') displayLabel = 'personalized';
      return `<button class="sub-btn" data-sub="${s}">${displayLabel}</button>`;
    }).join('');
    
    subRow.querySelectorAll('.sub-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const already = btn.classList.contains('active');
        subRow.querySelectorAll('.sub-btn').forEach(b => b.classList.remove('active'));
        if(!already){ btn.classList.add('active'); activeSub = btn.dataset.sub; }
        else activeSub = '';
        renderGrid();
      });
    });
  } else {
    subRow.classList.add('hidden');
    subRow.innerHTML = '';
  }
  renderGrid();
}

/* ── Init ── */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cat-btn').forEach(btn => btn.addEventListener('click', () => {
    const cat = btn.dataset.cat;
    setCategory(cat);
    // Update URL param without reloading — keeps back-button and sharing correct
    const url = new URL(window.location.href);
    if(cat === 'all') { url.searchParams.delete('type'); }
    else { url.searchParams.set('type', cat); }
    history.replaceState(null, '', url.toString());
  }));

  /* ── Filters ── */
  // Personalised filter
  const personCb = document.getElementById('filterPersonalized');
  if(personCb) {
    personCb.addEventListener('change', () => {
      activeFilters.personalized = personCb.checked;
      renderGrid();
    });
  }

  const engraveCb = document.getElementById('filterEngraved');
  if(engraveCb) {
    engraveCb.addEventListener('change', () => {
      activeFilters.engraved = engraveCb.checked;
      renderGrid();
    });
  }

  // Stone filter checkboxes are built and wired by buildStoneFilter() above.
  // Metal (gold) filter — static HTML in template
  document.querySelectorAll('input[data-filter="gold"]').forEach(cb => {
    cb.addEventListener('change', () => {
      activeFilters.gold = [...document.querySelectorAll('input[data-filter="gold"]:checked')].map(x => x.value);
      renderGrid();
    });
  });

  const priceSlider = document.getElementById('priceSlider');
  const priceVal = document.getElementById('priceVal');
  const maxPrice = parseInt(priceSlider?.max || 50000);

  // Set initial slider display
  if(priceVal) priceVal.textContent = fmt(maxPrice);

  if(priceSlider){
    priceSlider.addEventListener('input', () => {
      activeFilters.price = parseInt(priceSlider.value);
      priceVal.textContent = fmt(activeFilters.price);
      renderGrid();
    });
  }

  function clearAll(){
    document.querySelectorAll('input[data-filter]').forEach(cb => cb.checked = false);
    if(priceSlider){ priceSlider.value = maxPrice; }
    if(priceVal) priceVal.textContent = fmt(maxPrice);
    activeFilters = {stone:[],gold:[],price:maxPrice, personalized: false, engraved: false};
    const engraveCbReset = document.getElementById('filterEngraved');
    if(engraveCbReset) engraveCbReset.checked = false;
    renderGrid();
  }

  /* ── Build stone filter dynamically from actual product data ── */
  (function buildStoneFilter() {
    const stoneContainer = document.getElementById('stoneFilters');
    if (!stoneContainer) return;

    // Stone → display colour mapping (extend as needed)
    const STONE_COLORS = {
      'garnet': '#6b1a2e', 'amethyst': '#6b3fa0', 'aquamarine': '#4a9eb5',
      'ruby': '#9b1c1c', 'blue-sapphire': '#1a3a6b', 'white-sapphire': '#e8e8e8',
      'emerald': '#1a5c36', 'pearl': '#f5f0e8', 'peridot': '#6b8c2a',
      'opal': '#a8d8ea', 'citrine': '#d4a017', 'turquoise': '#3a9a8c',
      'moissanite': '#b8d4e8', 'diamond': '#f0f0f0', 'lab-diamond': '#e8f4f8',
      'plain': 'var(--gold)'
    };
    const LIGHT_STONES = new Set(['white-sapphire', 'pearl', 'opal', 'diamond', 'lab-diamond', 'plain']);

    // Extract unique stones from PRODUCTS data
    const stonesInCollection = [...new Set(PRODUCTS.map(p => p.stone).filter(Boolean))].sort();

    if (stonesInCollection.length <= 1 && stonesInCollection[0] === 'plain') {
      // No meaningful stone variation — hide the entire stone filter group
      const stoneGroup = stoneContainer.closest('.filter-group');
      if (stoneGroup) stoneGroup.style.display = 'none';
      return;
    }

    stoneContainer.innerHTML = stonesInCollection.map(stone => {
      const color = STONE_COLORS[stone] || '#999';
      const border = LIGHT_STONES.has(stone) ? 'border-color:#ccc;' : '';
      const label = stone.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
      return `
        <label class="filter-opt">
          <input type="checkbox" data-filter="stone" value="${stone}">
          <span class="filter-check"></span>
          <span class="stone-dot" style="background:${color};${border}"></span>
          <span class="filter-opt-label">${label}</span>
        </label>`;
    }).join('');

    // Re-attach event listeners for newly built checkboxes
    stoneContainer.querySelectorAll('input[data-filter="stone"]').forEach(cb => {
      cb.addEventListener('change', () => {
        activeFilters.stone = [...document.querySelectorAll('input[data-filter="stone"]:checked')].map(x => x.value);
        renderGrid();
      });
    });
  })();

  if(document.getElementById('clearFilters')) document.getElementById('clearFilters').addEventListener('click', clearAll);
  if(document.getElementById('clearFilters2')) document.getElementById('clearFilters2').addEventListener('click', clearAll);

  const sortSel = document.getElementById('sortSelect');
  if(sortSel) {
    // Apply page-level default sort if set (e.g. by alternate collection templates)
    if(window.COLLECTION_DEFAULT_SORT && window.COLLECTION_DEFAULT_SORT !== 'default') {
      sortSel.value = window.COLLECTION_DEFAULT_SORT;
    }
    sortSel.addEventListener('change', renderGrid);
  }

  /* ── Filter drawer open/close ── */
  const filtersSidebar = document.getElementById('filtersSidebar');
  const filterOverlay  = document.getElementById('filterOverlay');
  const filterToggle   = document.getElementById('filterToggle');
  const filterClose    = document.getElementById('filterClose');

  function openFilters() {
    if (filtersSidebar) filtersSidebar.classList.add('open');
    if (filterOverlay)  filterOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeFilters() {
    if (filtersSidebar) filtersSidebar.classList.remove('open');
    if (filterOverlay)  filterOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  if (filterToggle)  filterToggle.addEventListener('click', openFilters);
  if (filterClose)   filterClose.addEventListener('click', closeFilters);
  if (filterOverlay) filterOverlay.addEventListener('click', closeFilters);

  // Initial check: Search params or Hash
  const params = new URLSearchParams(window.location.search);
  const hash = window.location.hash.replace('#', '');
  
  if(params.has('type')) {
    const typeParam = params.get('type').toLowerCase();
    if (typeParam === 'personalized') {
      const personCbInit = document.getElementById('filterPersonalized');
      if (personCbInit) personCbInit.checked = true;
      activeFilters.personalized = true;
      renderGrid();
    } else if (typeParam === 'engraved') {
      const engraveCbInit = document.getElementById('filterEngraved');
      if (engraveCbInit) engraveCbInit.checked = true;
      activeFilters.engraved = true;
      renderGrid();
    } else {
      setCategory(typeParam);
    }
  } else if(hash) {
    setCategory(hash);
  } else {
    renderGrid();
  }
});
